import APICall from "../utils/APICall";

export default class CustomerServices {
  static listCustomers = async (
    page,
    pageLimit,
    search,
    from,
    to,
    registrationStage
  ) => {
    var url = `/api/Customer/admin/listCustomers?page=${page}&pageLimit=${pageLimit}`;
    if (search) url = `${url}&search=${search}`;
    if (from) url = `${url}&from=${from}`;
    if (to) url = `${url}&to=${to}`;
    if (registrationStage)
      url = `${url}&registrationStage=${registrationStage}`;
    return await APICall(url, "GET");
  };
  static getSummary = async () => {
    return await APICall("/api/Customer/admin/customers-summary", "GET");
  };
  static viewCustomer = async (identifier) => {
    const params = new URLSearchParams();
    if (identifier && typeof identifier === "object") {
      if (
        identifier.userId !== undefined &&
        identifier.userId !== null &&
        identifier.userId !== ""
      )
        params.set("userId", identifier.userId);
      else params.set("userName", identifier.userName ?? "");
    } else {
      params.set("userName", identifier ?? "");
    }
    return await APICall(
      `/api/Customer/admin/viewCustomer?${params.toString()}`,
      "GET"
    );
  };
  static viewCustomerBvn = async (bvn) => {
    return await APICall(
      `/api/Customer/admin/viewCustomerBvn?bvn=${bvn}`,
      "GET"
    );
  };
  static blockCustomer = async (userName) => {
    return await APICall(
      `/api/Customer/admin/block-customer`,
      "POST",
      userName
    );
  };
  static unLockCustomer = async (payload) => {
    return await APICall(
      "/api/Customer/admin/unlock-customer",
      "POST",
      payload
    );
  };
  static UnBlockCustomer = async (payload) => {
    return await APICall(
      "/api/Customer/admin/unblock-customer-profile",
      "POST",
      payload
    );
  };
  static unblockAccount = async (accountNumber) => {
    return await APICall(
      `/api/Customer/admin/unblock-customer-account/`,
      "POST",
      accountNumber
    );
  };
  static syncBVN = async (payload, silent) => {
    return await APICall(
      "/api/Customer/admin/sync-bvnDetails",
      "POST",
      payload,
      undefined,
      silent
    );
  };
  static bnvDetailsSync = async (payload) => {
    return await APICall(
      "/api/BvnDetails/admin/bvnDetails-sync",
      "POST",
      payload
    );
  };
  static listSettings = async (userName) => {
    return await APICall(
      `/api/Customer/admin/list-settings?userName=${userName}`,
      "GET"
    );
  };
  static blockAccount = async (userId) => {
    return await APICall(
      "/api/Customer/admin/block-customer-accounts",
      "POST",
      userId
    );
  };
  static verficationMail = async (payload) => {
    return await APICall(
      "/api/Customer/admin/resend-mail-verification",
      "POST",
      payload
    );
  };
  static exportList = async (search, from, to, registrationStage) => {
    return await APICall(
      `/api/Customer/admin/export-customers?search=${search}&from=${from}&to=${to}&registrationStage=${registrationStage}`,
      "GET"
    );
  };
  static exceptionalLimit = async (payload) => {
    var formData = new FormData();
    Object.keys(payload).forEach((key) => {
      if (payload[key] != null) formData.append(key, payload[key]);
    });
    return await APICall(
      "/api/Customer/admin/assign-exceptional-limit",
      "POST",
      formData
    );
  };
  static rejectExceptionLimit = async (payload) => {
    return await APICall(
      "/api/Customer/admin/reject-exceptional-limit",
      "POST",
      payload
    );
  };
  //    security features
  static securityMode = async (payload) => {
    return await APICall(
      "/api/Customer/admin/disable-customer-security-modes",
      "POST",
      payload
    );
  };
  static resetProfile = async (payload) => {
    return await APICall(
      `/api/Customer/admin/customer-profile-reset`,
      "POST",
      payload
    );
  };
  static exportNewToBank = async () => {
    return await APICall(`/api/admin/export-new-to-bank`, "GET");
  };
  static updateCustomerLimit = async (username, payload) => {
    return await APICall(
      `/api/Customer/admin/customer/limit/${username}`,
      "POST",
      payload
    );
  };
  static rejectCustomerLimit = async (username) => {
    return await APICall(
      `/api/Customer/admin/customer/reject/limit/${username}`,
      "POST"
    );
  };
  static setDefaultLimit = async (payload) => {
    return await APICall(
      `/api/Customer/admin/set-default-limit`,
      "POST",
      payload
    );
  };
  static clearCustomerCache = async (payload) => {
    const url = `/api/Customer/admin/clear-customer-cache-data`;
    return await APICall(url, "POST", payload);
  };

  static GetReviews = async (
    application,
    pageIndex = 1,
    pageSize = 10,
    startDate = "",
    endDate = ""
  ) => {
    return await APICall(
      `/api/Customer/admin/view-paginated-ratings?application=${application}&pageIndex=${pageIndex}&pageSize=${pageSize}&startDate=${startDate}&endDate=${endDate}`,
      "GET"
    );
  };

  static exportRatings = async (application, pageIndex = 1, pageSize = 10, startDate = "", endDate = "") => {
    return await APICall(
      `/api/Customer/admin/paginated-ratings/export?application=${application}&pageIndex=${pageIndex}&pageSize=${pageSize}&startDate=${startDate}&endDate=${endDate}`,
      "GET"
    );
  };

  static ClearAllApplicationData = async () => {
    const url = `/api/Customer/admin/purge-all-application-cache-data`;
    return await APICall(url, "POST");
  };

  static initiateProfileUpdate = async (payload) => {
    return await APICall(
      "/api/Customer/admin/initiate-customer-profile-update",
      "POST",
      payload
    );
  };

  static approveOrRejectProfileUpdate = async (payload) => {
    return await APICall(
      "/api/Customer/admin/approve-or-reject-customer-profile-update",
      "POST",
      payload
    );
  };

static listApprovals = async (pageNumber = 1, pageSize = 10, status = "", approvalTag = "", search = "", startDate = "", endDate = "") => {
  let url = `/api/Customer/admin/list-approvals?pageNumber=${pageNumber}&pageSize=${pageSize}`;
  if (status) url = `${url}&status=${status}`;
  if (approvalTag) url = `${url}&approvalTag=${approvalTag}`;
  if (search) url = `${url}&search=${search}`;
  if (startDate) url = `${url}&startDate=${startDate}`;
  if (endDate) url = `${url}&endDate=${endDate}`;
  return await APICall(url, "GET");
};

 static viewApprovalDetails = async (userId) => {
  return await APICall(
    `/api/Customer/admin/view-approval-details?userId=${userId}`,
    "GET"
  );
};

static initiateAccountProfileUpdate = async (payload) => {
  return await APICall(
    "/api/Customer/admin/update-user-account-profile",
    "POST",
    payload
  );
};

static approveOrRejectAccountProfileUpdate = async (payload) => {
  return await APICall(
    "/api/Customer/admin/approve-or-reject-customeraccount-profile-update",
    "POST",
    payload
  );
};

static listAccountApprovals = async (pageNumber = 1, pageSize = 10, status = "", approvalTag = "", search = "", startDate = "", endDate = "") => {
  let url = `/api/Customer/admin/list-account-approvals?pageNumber=${pageNumber}&pageSize=${pageSize}`;
  if (status) url = `${url}&status=${status}`;
  if (approvalTag) url = `${url}&approvalTag=${approvalTag}`;
  if (search) url = `${url}&search=${search}`;
  if (startDate) url = `${url}&startDate=${startDate}`;
  if (endDate) url = `${url}&endDate=${endDate}`;
  return await APICall(url, "GET");
};

  static viewAccountApprovalDetails = async (accountId) => {
  return await APICall(
    `/api/Customer/admin/view-account-approval-details?accountId=${accountId}`,
    "GET"
  );
};

  static listOnboardingStatusHistory = async (page, pageLimit, search, startDate, endDate) => {
    var url = `/api/Customer/admin/list-onboarding-status-history?page=${page}&pageLimit=${pageLimit}`;
    if (search) url = `${url}&search=${search}`;
    if (startDate) url = `${url}&startDate=${startDate}`;
    if (endDate) url = `${url}&endDate=${endDate}`;
    return await APICall(url, "GET");
  };

  static viewOnboardingStatusHistory = async (id) => {
    return await APICall(
      `/api/Customer/admin/view-onboarding-status-history/${id}`,
      "GET"
    );
  };

  static exportOnboardingStatusHistory = async (page, pageLimit, search, startDate, endDate) => {
    var url = `/api/Customer/admin/export-onboarding-status-history?page=${page}&pageLimit=${pageLimit}`;
    if (search) url = `${url}&search=${search}`;
    if (startDate) url = `${url}&startDate=${startDate}`;
    if (endDate) url = `${url}&endDate=${endDate}`;
    return await APICall(url, "GET");
  };

  static syncNinDetails = async (payload, silent) => {
    return await APICall(
      "/api/Customer/admin/sync-ninDetails",
      "POST",
      payload,
      undefined,
      silent
    );
  };

  static reInitiateOnboarding = async (payload, silent) => {
    return await APICall(
      "/api/Customer/admin/ReInitiate-customer-onboarding",
      "POST",
      payload,
      undefined,
      silent
    );
  };

  static listAccountOpeningApprovals = async (
    pageNumber = 1,
    pageSize = 10,
    status = "",
    search = "",
    startDate = "",
    endDate = ""
  ) => {
    let url = `/api/Customer/admin/list-account-opening-approvals?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (status) url = `${url}&status=${status}`;
    if (search) url = `${url}&search=${search}`;
    if (startDate) url = `${url}&startDate=${startDate}`;
    if (endDate) url = `${url}&endDate=${endDate}`;
    return await APICall(url, "GET");
  };

  static viewAccountOpeningApproval = async (approvalId) => {
    return await APICall(
      `/api/Customer/admin/view-account-opening-approval?approvalId=${approvalId}`,
      "GET"
    );
  };

  static approveOrRejectAccountOpening = async (payload) => {
    return await APICall(
      "/api/Customer/admin/approve-reject-account-opening",
      "POST",
      payload
    );
  };

  static listVerificationEmails = async (pageNumber, pageSize, deviceID, search, startDate, endDate) => {
    var url = `/api/Customer/admin/list-verification-emails?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (deviceID) url = `${url}&deviceID=${deviceID}`;
    if (search) url = `${url}&search=${search}`;
    if (startDate) url = `${url}&startDate=${startDate}`;
    if (endDate) url = `${url}&endDate=${endDate}`;
    return await APICall(url, "GET");
  };

  static viewVerificationEmail = async (verificationEmailId) => {
    return await APICall(
      `/api/Customer/admin/view-verification-email?verificationEmailId=${verificationEmailId}`,
      "GET"
    );
  };

  static exportVerificationEmails = async (pageNumber, pageSize, deviceID, search, startDate, endDate) => {
    var url = `/api/Customer/admin/export-verification-emails?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (deviceID) url = `${url}&deviceID=${deviceID}`;
    if (search) url = `${url}&search=${search}`;
    if (startDate) url = `${url}&startDate=${startDate}`;
    if (endDate) url = `${url}&endDate=${endDate}`;
    return await APICall(url, "GET");
  };
}
